import { render, staticRenderFns } from "./AuthorityRequestList.vue?vue&type=template&id=5f339c21"
import script from "./AuthorityRequestList.vue?vue&type=script&lang=js"
export * from "./AuthorityRequestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports